import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSettingsSliderVer: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSettingsSliderVer"><Path d="M17.75 13.0701C19.6011 13.421 21 15.0465 21 17C21 19.2098 19.2098 21 17 21C14.7902 21 13 19.2098 13 17C13 15.0465 14.3989 13.421 16.25 13.0701V3H17.75V13.0701Z" fill="currentColor"/><Path d="M6.25 5.07014C4.3989 5.421 3 7.04652 3 9C3 10.9535 4.3989 12.579 6.25 12.9299V21H7.75V12.9299C9.6011 12.579 11 10.9535 11 9C11 7.04652 9.6011 5.421 7.75 5.07014V3H6.25V5.07014Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSettingsSliderVer;
